
<div class="">
    <nz-tree-select
    style="width: 100%;  margin-bottom: 12px; padding: 1em;"
    [nzNodes]="treeNodes"
    nzAllowClear
    nzShowSearch
    nzPlaceHolder="Seleccione un grupo o sub-grupo"
    [(ngModel)]="seleccion"
    (ngModelChange)="onPick($event)">
    </nz-tree-select>
</div>

